// src/context/ConfigContext.tsx
import React, { createContext, ReactNode, useContext, useEffect, useState } from "react";
import { UserConfig, ConfigContextType } from "../types";
import { api } from "../services/api";
export const ConfigContext = createContext<ConfigContextType | undefined>(undefined);

export const ConfigProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [config, setConfig] = useState<UserConfig | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  
  // 🚀 Load config when app mounts
  useEffect(() => {
    loadConfig();
  }, []);

  const loadConfig = async () => {
    try {
      const res = await api.app.getCurrentUser();
      setConfig(res.config);
    } catch (err) {
      console.error("Failed to load config:", err);
      setConfig(undefined);
    } finally {
      setLoading(false);
    }
  };

  // Update user config on server (cookie-based)
  const updateConfig = async (updates: Partial<UserConfig>) => {
    if (!updates || Object.keys(updates).length === 0) return;
    try {
      const res = await api.app.updateUserConfig(updates)
      setConfig((prev) => ({ ...prev, ...res }));
    } catch (err) {
      console.error("Failed to update config:", err);
    }
  };

  const clearContext = () => setConfig(undefined);

  return (
    <ConfigContext.Provider value={{ config, loading, updateConfig, getConfig: loadConfig, clearContext }}>
      {children}
    </ConfigContext.Provider>
  );
};

// custom hook
export const useConfig = () => {
  const context = useContext(ConfigContext);
  if (!context) throw new Error("useConfig must be used inside ConfigProvider");
  return context;
};
